import {
    useCallback,
    useMemo,
} from 'react'

import SkyNetDataGridExpandable
    from 'app/PoC/DataGridDemoPages/components/SkyNetDataGridExpandable/SkyNetDataGridExpandable'
import useDataGridSource from 'app/PoC/DataGridDemoPages/components/hooks/useDataGridSource'
import {
    ContractBasisContext,
} from 'app/Apps/Pricing/ContractBasis/hooks/useContractBasisContext'
import {
    DataGridSupportedFeatures,
} from 'app/PoC/DataGridDemoPages/components/SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'
import ContractBasisRequests from 'app/requests/ContractBasis/ContractBasis.requests'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    ContractBasis,
} from 'app/Apps/Pricing/Pricing.types'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'

import columns from './ContractBasisDemoLaneGroups.columns'
import LaneGroupsCreate from './LaneGroupsCreate'

const toolbarControls = [DataGridSupportedFeatures.ShowArchived]

const ContractBasisDemoLaneGroups = ({
    data,
}: Readonly<{
    data: ContractBasis
}>) => {
    const {
        LaneGroups: LaneGroupsRoutes,
    } = usePricingRoutes()
    const request = useMemo(() => {
        return ContractBasisRequests.filterRequestLaneGroups({
            contractId: data.id,
            params: {},
        })
    }, [data.id])

    const dataSource = useDataGridSource({
        request,
        key: 'getContractBasisLaneGroups' as RequestKeys,
        rowsPerPage: 200,
    })

    const onRowClick = useCallback(({
        id,
    }: { id: number }) => {
        LaneGroupsRoutes.Overview.navigate({
            params: {
                key: id,
            },
            options: {
                state: {
                    filter: {
                        customerQuotationLocationName: [data?.customerQuotation?.locationName],
                        pricingAccountCompanyName: [data?.account?.company?.companyName],
                        contractBasisCurrency: [data?.currency],
                    },
                },
            },
        })
    }, [
        LaneGroupsRoutes.Overview,
        data,
    ])

    const contractBasisContext = useMemo(() => {
        return {
            contractId: data?.id,
        }
    }, [data])

    return (
        <ContractBasisContext.Provider value={contractBasisContext}>
            <SkyNetDataGridExpandable
                persistentKey="contract-basis-lane-groups-demo-table"
                columns={columns}
                customDataSource={dataSource}
                toolbarProps={{
                    title: 'Lane Groups',
                    toolbarControls: [],
                }}
                featuresLists={toolbarControls}
                ActionComponents={{
                    Create: {
                        component: LaneGroupsCreate,
                        onSuccess: onRowClick,
                        accessOnly: ['contract_basis_create'],
                    },
                }}
                onRowClick={onRowClick}
            />
        </ContractBasisContext.Provider>
    )
}

export default ContractBasisDemoLaneGroups
